export default "__VITE_ASSET__$QWT1G7s__"